import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./changePassword.css";

import { Input } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { updateFirstLogin } from "../../store/user/actions";
import { getMetaCsrf } from "../../util/basicRenders";

const REGEX_UPPER_CASE = /[A-Z]+/;
const REGEX_DIGI_CASE = /[0-9]+/;
const REGEX_SYMBOL_CASE = /[$&+,:;=?@#|'<>.^*()%!-]+/;

const ChangePassword = () => {

  const userEmail = useSelector(state => state.user?.email)
  const firstLogin = useSelector(state => state.user?.firstLogin ? state.user.firstLogin : true)

  const [oldpassword, setPassword] = useState("");
  const [newpassword, setNewPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [showError, setShowError] = useState(false);
  const [check, setCheck] = useState(false);
  const [showError2, setShowError2] = useState(false);
  const [oldCheck, setOldCheck] = useState(false);
  const [weakPassword, setWeakPassword] = useState(false);
  const [showWeakPassword, setShowWeakPassword] = useState(false);

  const navigate = useNavigate();
  const dispatchito = useDispatch();

  useEffect(() => {
    if(newpassword && (newpassword.length < 8 || !REGEX_DIGI_CASE.test(newpassword) || !REGEX_UPPER_CASE.test(newpassword) || !REGEX_SYMBOL_CASE.test(newpassword))){
      setWeakPassword(true);
    }
    else{
      setWeakPassword(false);
    }
  }, [newpassword]);

  //checks the requirements for the fields
  useEffect(() => {
    if (
      oldpassword &&
      newpassword &&
      confirmpassword &&
      newpassword === confirmpassword &&
      !weakPassword
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [oldpassword, newpassword, confirmpassword, userEmail]);

  useEffect(() => {
    if (check) {
      if (oldpassword && confirmpassword && newpassword && confirmpassword && newpassword!==confirmpassword){
        setShowError2(true);
        setShowError(false);
      }
      else{
        setShowError(true);
        setShowError2(false);
      }
    }
  }, [check]);

  //handlers
  const handleSubmit = async e => {
    setShowError(false);
    setShowError2(false);
    setCheck(false);
    setOldCheck(false);
    setShowWeakPassword(false);
    e.preventDefault();
    try {
      const checkPasswordResponse = await fetch(
        `/api/user/checkexistingpassword/${userEmail}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-csrf-token": getMetaCsrf()
          },
          body: JSON.stringify({ password: oldpassword })
        }
      );

      const checkPasswordData = await checkPasswordResponse.json();

      if (!checkPasswordResponse.ok || disabled) {
        throw new Error(checkPasswordData.msg || "Error checking password");
      }
      const changePasswordResponse = await fetch(
        `/api/user/changeexistingpassword/${userEmail}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-csrf-token": getMetaCsrf()
          },
          body: JSON.stringify({ newPassword: newpassword })
        }
      );

      const changePasswordData = await changePasswordResponse.json();

      if (!changePasswordResponse.ok || disabled) {
        throw new Error(changePasswordData.msg || "Error changing password");
      }

      if (firstLogin) {
        dispatchito(updateFirstLogin({callback: () => {
          // If RAM tokens exist, this is an audit-only user — redirect to internal-audit app
          const hasRamTokens = localStorage.getItem('ramToken') && localStorage.getItem('ramRefreshToken');
          if (hasRamTokens) {
            window.location.href = '/internal-audit/';
          } else {
            navigate("/home-page");
          }
        }}))
      } else {
        // Also check for RAM tokens in the non-firstLogin case
        const hasRamTokens = localStorage.getItem('ramToken') && localStorage.getItem('ramRefreshToken');
        if (hasRamTokens) {
          window.location.href = '/internal-audit/';
        } else {
          navigate("/home-page");
        }
      }
      
    } catch (error) {
      if (!disabled){
        setOldCheck(true);
      } else if (weakPassword) {
        setShowWeakPassword(true);
      }
      else{
        setCheck(true);
      }
    }
  };

  return (
    <form className="change" id="change-page" onSubmit={handleSubmit}>
      <header id="change-password-header">
        <h1 id="change-title">Change your password</h1>
      </header>
      <div id="change-content">
        <div className="form-group" id="change-page-form-group">
          <label id="labelEmail">Email</label>
          <Input
            id="inputEmail"
            type="email"
            // onChange={e => setEmail(e.target.value)}
            value={userEmail}
            // required
            disabled
          />
          {/* <span id="error-message">Invalid username or password.</span> */}
        </div>
        <div className="form-group" id="change-page-form-group-2">
          <label id="labelPassword">Old Password</label>
          <Input
            id="inputPasswordOld"
            type="password"
            onChange={e => setPassword(e.target.value)}
            value={oldpassword}
            // required
          />
        </div>
        {oldCheck ? 
          <>
            <span id="error-message3">
              Incorrect old password
            </span>
            <br></br>
            <br></br>
          </>
          :
          <></>
        }
        <div className="form-group" id="change-page-form-group-3">
          <label id="labelPassword">New Password</label>
          <Input
            id="inputPasswordNew1"
            type="password"
            onChange={e => setNewPassword(e.target.value)}
            value={newpassword}
            // required
          />
          {showWeakPassword ? 
          <>
            <span id="error-message4">
              New password isn't strong enough
            </span>
            <br></br>
            <br></br>
          </>
          :
          <></>
        }
        </div>
        <div className="form-group" id="change-page-form-group-4">
          <label id="labelPassword">Confirm New Password</label>
          <Input
            id="inputPasswordNew2"
            type="password"
            onChange={e => setConfirmPassword(e.target.value)}
            value={confirmpassword}
            // required
          />
        </div>

        {showError ? 
          <>
            <span id="error-message">
              Some required fields are missing
            </span>
            <br></br>
            <br></br>
          </>
          :
          <></>
        }

        {showError2 ? 
          <>
            <span id="error-message2">
              Confirm New Password has to be the same as New Password
            </span>
            <br></br>
            <br></br>
          </>
          :
          <></>
        }

        <button className="cursor-pointer" id="change-page-cursor-password">
          Change Password
        </button>

        <div id="info-text">
          <span>Please fill in all fields to change your password.</span>
        </div>
      </div>
    </form>
  );
};

export default ChangePassword;
